import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialGroupItemCategoryState: Dtos.TrialGroupItemCategory & IRegistrationFormState = {
    categoryId: null,
    trialGroupItemTemplateCategory: null,
    trialGroupItems: [],
    trialGroupItemSummaries: [],
    saveAndReturn: null
}

export interface ITrialGroupItemCategoryReduxFormState {
    categoryId: IFieldState<number>,
    trialGroupItemTemplateCategory: IFieldState<Dtos.TrialGroupItemTemplateCategory>,
    trialGroupItems: IFieldState<Dtos.TrialGroupItem[]>,
    trialGroupItemSummaries: IFieldState<Dtos.TrialGroupItemSummary[]>
}
